import { CANProvinces, USAStates } from '@getgreenline/companies'
import { AppType, GlobalStore } from '../stores/GlobalStore'
import { Country } from '@getgreenline/homi-shared'

export class GlobalDynamicVariables {
  static labels = {
    postalCode: (country?: Country) => {
      switch (country) {
        case 'USA':
          return 'Zip Code'
        default:
          return 'Postal Code'
      }
    },
    stateOrProvince: (country?: Country) => {
      switch (country) {
        case 'USA':
          return 'State'
        default:
          return 'Province'
      }
    },
  }

  static vars = {
    stateOrProvince: (country?: Country) => {
      switch (country) {
        case 'USA':
          return USAStates
        default:
          return CANProvinces
      }
    },
  }

  static availability = {
    companyStateOrProvince: (country?: Country) => {
      switch (country) {
        case 'USA':
          return false
        default:
          return true
      }
    },
    outreach: () => {
      switch (GlobalStore.appType) {
        case AppType.BLAZEPOS:
          return false
        default:
          return true
      }
    },
    terpene: () => {
      switch (GlobalStore.appType) {
        case AppType.BLAZEPOS:
          return false
        default:
          return true
      }
    },
    blazeCapital: () => {
      switch (GlobalStore.appType) {
        case AppType.BLAZEPOS:
          return false
        default:
          return true
      }
    },
    complianceReport: () => {
      switch (GlobalStore.appType) {
        case AppType.BLAZEPOS:
          return false
        default:
          return true
      }
    },
    invoiceProvinceImport: () => {
      switch (GlobalStore.appType) {
        case AppType.BLAZEPOS:
          return false
        default:
          return true
      }
    },
    merrcoMoneris: () => {
      switch (GlobalStore.appType) {
        case AppType.BLAZEPOS:
          return false
        default:
          return true
      }
    },
    legacyKnowledgeBase: () => {
      switch (GlobalStore.appType) {
        case AppType.BLAZEPOS:
          return false
        default:
          return true
      }
    },
    trainingSessions: () => {
      switch (GlobalStore.appType) {
        case AppType.BLAZEPOS:
          return false
        default:
          return true
      }
    },
  }

  private constructor() {}
}
